import React, { useState, useEffect } from "react";
import axios from 'axios';
import style from './Sell.module.css';

const Sell = () => {
    const [formData, setFormData] = useState({
        nombre: '',
        mail: '',
        telefono: '',
        tipoPropiedad: 'departamento',
        mensaje: '',
    });
    const [isSending, setIsSending] = useState(false);
    const [status, setStatus] = useState({ type: '', message: '' });

    useEffect(() => {
        if (!status.message) return undefined;

        const timer = setTimeout(() => {
            setStatus({ type: '', message: '' });
        }, 4000);

        return () => clearTimeout(timer);
    }, [status.message]);

    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData((current) => ({ ...current, [name]: value }));
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        setIsSending(true);
        setStatus({ type: '', message: '' });

        try {
            const response = await axios.post('/contacto', {
                nombre: formData.nombre.trim(),
                mail: formData.mail.trim(),
                telefono: formData.telefono.trim(),
                asunto: `Venta de propiedad - ${formData.tipoPropiedad}`,
                mensaje: formData.mensaje.trim(),
                origen: 'web',
            });

            if (!response.data.success) {
                throw new Error(response.data.message || 'No se pudo enviar la consulta');
            }

            setFormData({
                nombre: '',
                mail: '',
                telefono: '',
                tipoPropiedad: 'departamento',
                mensaje: '',
            });
            setStatus({
                type: 'success',
                message: 'Tu propiedad fue registrada correctamente. Nos contactaremos a la brevedad.',
            });
        } catch (error) {
            setStatus({
                type: 'error',
                message: error.response?.data?.message || 'No pudimos enviar tu consulta. Intentá nuevamente.',
            });
        } finally {
            setIsSending(false);
        }
    };

    return(
        <div className={style.formContent}>
            <div className={style.layout}>
                <div className={style.infoPanel}>
                    <span className={style.infoEyebrow}>Vender con nosotros</span>
                    <h1 className={style.infoTitle}>Tu propiedad, en las mejores manos</h1>
                    <p className={style.infoText}>
                        En By Raíces trabajamos con transparencia, cercanía y conocimiento real del mercado.
                        Cada propiedad que sumamos es acompañada por un agente especializado que se
                        encarga de todo el proceso de comercialización de tu inmueble, de principio a fin.
                    </p>

                    <div className={style.infoValues}>
                        <div className={style.infoValueItem}>
                            <span className={style.infoValueIcon}>🤝</span>
                            <div>
                                <h3 className={style.infoValueTitle}>Acompañamiento personalizado</h3>
                                <p className={style.infoValueText}>Un agente especializado va a trabajar tu consulta y te va a contactar a la brevedad.</p>
                            </div>
                        </div>
                        <div className={style.infoValueItem}>
                            <span className={style.infoValueIcon}>📈</span>
                            <div>
                                <h3 className={style.infoValueTitle}>Conocimiento del mercado</h3>
                                <p className={style.infoValueText}>Tasamos con criterio real, basado en la zona y el estado de tu propiedad.</p>
                            </div>
                        </div>
                        <div className={style.infoValueItem}>
                            <span className={style.infoValueIcon}>⚖️</span>
                            <div>
                                <h3 className={style.infoValueTitle}>Respaldo profesional</h3>
                                <p className={style.infoValueText}>Todas las operaciones son intermediadas por corredores públicos matriculados.</p>
                            </div>
                        </div>
                    </div>
                </div>

             <div className={style.card}>
             <h2 className={style.title} >Vendé tu propiedad</h2>
             <p className={style.text}>Completá el formulario y nos pondremos contacto con vos para continuar con el proceso</p>

             <form className={style.mailForm} onSubmit={handleSubmit}>
                <label className={style.mailLabel} htmlFor="nombre">Nombre</label>
                <input className={style.inputText} type="text" name='nombre' id='nombre' value={formData.nombre} onChange={handleChange} placeholder="Tu nombre" required />

                <label className={style.mailLabel} htmlFor="mail">Correo electrónico</label>
                <input className={style.inputText} type="email" name='mail' id='mail' value={formData.mail} onChange={handleChange} placeholder="tuemail@mail.com" required />

                <label className={style.mailLabel} htmlFor="telefono">Teléfono</label>
                <input className={style.inputText} type="tel" name='telefono' id='telefono' value={formData.telefono} onChange={handleChange} placeholder="+54 9 11 1234 5678" />

                <label className={style.mailLabel} htmlFor="tipoPropiedad">Tipo de propiedad</label>
                <select className={style.inputText} name="tipoPropiedad" id="tipoPropiedad" value={formData.tipoPropiedad} onChange={handleChange}>
                    <option value="departamento">Departamento</option>
                    <option value="casa">Casa</option>
                    <option value="ph">PH</option>
                    <option value="local">Local</option>
                    <option value="terrenos y lotes">Terrenos y lotes</option>
                    <option value="campos y chacras">Campos y chacras</option>
                    <option value="fondo de comercio">Fondo de comercio</option>
                    <option value="cochera">Cochera</option>
                    <option value="oficina">Oficina</option>
                    <option value="galpon">Galpón</option>
                    <option value="quinta">Quinta</option>
                    <option value="otros">Otros</option>
                </select>

                <label className={style.mailLabel} htmlFor="mensaje">Comentarios</label>
                <textarea className={style.inputText} name="mensaje" id="mensaje" cols="30" rows="5" value={formData.mensaje} onChange={handleChange} placeholder="Contanos sobre tu propiedad..." required></textarea>

                <button className={style.btn} type="submit" disabled={isSending}>
                  {isSending ? 'Enviando...' : 'Enviar'}
                </button>

                {status.message && (
                  <div
                    className={`${style.toast} ${status.type === 'success' ? style.toastSuccess : style.toastError}`}
                    role="status"
                    aria-live="polite"
                  >
                    {status.message}
                  </div>
                )}
             </form>
        </div>
            </div>
        </div>
    );
};

export default Sell